/** @module polyfills */

/**
 * Ensures support for Intersection Observer API
 * @see https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserver
 */
export function intersectionObserver() {
    if (
        !('IntersectionObserver' in window) ||
        !('IntersectionObserverEntry' in window) ||
        !('intersectionRatio' in window.IntersectionObserverEntry.prototype)
    ) {
        import(/* webpackMode: "eager" */ 'intersection-observer');
    }
}
